import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Autocomplete,
  TextField,
  Box,
  IconButton,
  FormControl,
  Stack,
  Pagination,
  TablePagination,
  Grid,
  Typography
} from "@mui/material";
import { data, Link, useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import Switch from "@mui/material/Switch";
import edit from "../../../assets/images/editIcon.png";
import {
  ApiGetClientEntities,
  ApiGetAdminList,
  ApiPutStoreStatus,
  ApiGetEntityTypeList,
  ApiGetBusinessExcel,
} from "../../../apiService/Core/Apicall.tsx";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../global/config/store.ts";
import useDebounce from "../CreateAllocations/UseDebounce.tsx"
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts";

const ManageStore: React.FC = () => {
  const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
  const dispatch = useDispatch()
  const [adminUsers, setAdminUsers] = useState<any>([]);
  const [clientEntityList, setClientEntityList] = useState<any>([]);
  const [status, setStatus] = useState({});
  const Clientlist = useSelector((state: RootState) => state.client.clientList);
  const [selectedClient, setSelectedClient] = useState<any>(selectedClientName);
  const [ClientId, setClientId] = useState(null);
  const [datalength, setdatalength] = useState<any>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [searchEntityName, setSearchEntityName] = useState("");
  const debouncedSearch = useDebounce(searchEntityName, 500);
  const [entityTypes, setEntityTypes] = useState<any[]>([]);
  const [selectedEntityType, setSelectedEntityType] = useState<any>(null);

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (Clientlist.length > 2) {
  //     // setSelectedClient(Clientlist[2]);
  //     setClientId(Clientlist[2].clientGroupName);
  //     console.log("selectedClient", selectedClient)
  //     console.log("ClientId", ClientId)
  //   }
  // }, [Clientlist]);

  useEffect(() => {
    setSelectedClient(selectedClientName)

  }, [selectedClientName])

  const handleGetApiCall = async () => {
    try {
      const response: any = await ApiGetAdminList();
      setAdminUsers(response.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleGetClientList = async () => {
    const data = `?offset=${page * rowsPerPage}&limit=${rowsPerPage}${selectedClient ? `&clientGroupName=${selectedClient.clientGroupName}` : ''}${debouncedSearch ? `&searchEntityName=${debouncedSearch}` : ""}${selectedEntityType ? `&entityTypeId=${selectedEntityType?.value}` : ''}&clientEntityStatus=active`;
    try {
      const response: any = await ApiGetClientEntities(data);
      setClientEntityList(response.data);
      setdatalength(response.totalDataCount);
      // console.log("rse store", response.data);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const deleteStore = async (store: any, newStatus: string) => {
    try {
      const body = {
        clientEntityId: store?.clientEntityId,
        status: newStatus,
      };
      const response: any = await ApiPutStoreStatus(body);
      toast.success("Business Deleted successfully");
      console.log("Status updated successfully:", response);
      await handleGetClientList();
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const addOrUpdateStore = (store?: any) => {
    if (store?.clientEntityId) {
      navigate(`/admin/add-or-update-store/update/${store?.clientEntityId}`, {
        state: { clientEntity: store },
      });
    } else {
      navigate("/admin/add-or-update-store/add");
    }
  };

  const navigateToViewEditors = (store?: any) => {
    navigate("/admin/view-editor-business", {
      state: { store },
    });
  };

  const navigateToViewJobCriteria = (store?: any) => {
    navigate("/admin/view-business-jobcriteria", {
      state: { store },
    });
  };
  const navigateToClientQuestion = (store?: any) => {
    // navigate("/admin/create-client-template", {
    //   state: { store },
    // });
    sessionStorage.setItem("businessQuestion", JSON.stringify({ ...store, clientGroupName: selectedClientName }))
    const url = `/admin/create-client-template`
    window.open(url, "_blank")
  };

  const navigateToQuizQuestion = (store?: any) => {
    navigate("/admin/create-quiz-question", {
      state: { store },
    });
  };

  const handleChange = async (store: any, newStatus: string) => {
    setStatus((prevStatus) => ({
      ...prevStatus,
      [store.clientEntityId.ClientID]: newStatus,
    }));

    setClientEntityList((prevList) =>
      prevList.map((item) =>
        item.clientEntityId === store.clientEntityId
          ? {
            ...item,
            clientEntityStatus: {
              ...item.clientEntityStatus,
              userStatus: newStatus,
            },
          }
          : item
      )
    );

    try {
      const body = {
        clientEntityId: store?.clientEntityId,
        status: newStatus,
      };
      const response: any = await ApiPutStoreStatus(body);
      handleGetApiCall();
      console.log("Status updated successfully:", response);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  useEffect(() => {
    console.log("Slected CLient", selectedClient)
    const fetchData = async () => {
      selectedClient !== null && await handleGetClientList();
      await handleGetApiCall();
    };
    fetchData();
    return () => { };
  }, [selectedClient, page, rowsPerPage, selectedEntityType]);

  // ------------------------------------------- Chnage Pagination -----------------------------------------------
  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    if (selectedClient) {
      handleGetClientList();
    }
  }, [debouncedSearch]);


  useEffect(() => {
    const fetchEntityTypes = async () => {
      try {
        const response: any = await ApiGetEntityTypeList();
        console.log("Entity types response", response.data);
        const transformedData = response.data.map((item: any) => ({
          value: item.entityTypeId,
          label: item.entityTypeName,
        }));

        setEntityTypes(transformedData);
      } catch (err) {
        console.error("Error fetching entity types:", err);
      }
    };

    fetchEntityTypes();
  }, []);

  const downaloadAsExcel = async () => {
    try {

      const res = await ApiGetBusinessExcel();

      const blob = new Blob([res], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Business.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      alert(error)
    }
  };

  return (
    <div className="w-100  px-2">
      <Box className='w-100 bg-white border-10 py-3'>
        <Grid container className='w-100 align-items-end p-2 p-md-3 mb-4' gap={{ xs: 3, md: 0 }}>
          <Grid size={{ xs: 12, md: 'auto' }} order={{ xs: 2, md: 1 }}>
            <Stack className=" d-flex align-items-start" gap={1} flexWrap={'wrap'} width={{ xs: "100%", md: 'fit-content' }} direction="row" >
              <FormControl size="small" className="col-md-auto col-xs-12" sx={{ width: { xs: "100%", md: 180 } }}>
                <Autocomplete
                  disablePortal
                  id="mm-autocomplete"
                  options={Clientlist}
                  value={selectedClient}
                  getOptionLabel={(option) => option?.clientGroupName}
                  isOptionEqualToValue={(option, value) =>
                    option.clientGroupDBName === value.clientGroupDBName
                  }
                  onChange={(event, newValue: any) => {
                    // setSelectedClient(newValue);
                    dispatch(setSelectedClientGroup(newValue))
                    setClientId(newValue?.clientGroupName || null);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Client" />
                  )}
                  size="small"
                />
              </FormControl>
              <FormControl size="small" className="col-md-auto col-xs-12" sx={{ width: { xs: "100%", md: 230 } }}>
                <Autocomplete
                  disablePortal
                  id="mm-autocomplete"
                  options={entityTypes}
                  value={selectedEntityType}
                  getOptionLabel={(option) => option?.label}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  onChange={(event, newValue: any) => {
                    setSelectedEntityType(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Select BusinessType" />
                  )}
                  size="small"
                />
              </FormControl>
              <FormControl size="small" className="col-md-auto col-xs-12" sx={{ width: { xs: "100%", md: 250 } }}>
                <TextField
                  label="Search Business"
                  size="small"
                  value={searchEntityName}
                  onChange={(e) => setSearchEntityName(e.target.value)}
                />
              </FormControl>
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 'grow' }} order={{ xs: 1, md: 2 }}>
            <Typography className=" text-center fs-42">Manage Business</Typography>
          </Grid>
          {/* <div style={{ gap: '5px'}}  className="add-button common-manage-button d-flex justify-content-between align-items-center border"> */}
          <Grid size={{ xs: 12, md: 'auto' }} order={{ xs: 3, md: 3 }}>
            <Stack
              direction={{ xs: "row" }}
              spacing={1}
              width={{ xs: "100%", md: 'fit-content' }}
              justifyContent={{ xs: "space-between", md: 'end' }}
            >
              <Button
                variant="contained"
                onClick={() => downaloadAsExcel()}
                className="table-row-background fs-14"
              >
                Export As Excel
              </Button>
              <Link
                to={"/admin/add-or-update-store/add"}
                // variant="contained"
                // onClick={() => addOrUpdateStore()}
                className="table-row-background link-btn fs-14"
              >
                Add New Business
              </Link>
              {/* </div> */}
            </Stack>
          </Grid>
        </Grid>
        <Box className='w-100 p-2 p-md-3' overflow={'auto'}>
          <Table>
            <TableHead>
              <TableRow className="table-row-background">
                <TableCell className="fs-14" style={{ color: "#fff" }}>ID</TableCell>
                <TableCell className="fs-14" style={{ color: "#fff" }}>Location Name</TableCell>
                <TableCell className="fs-14" style={{ color: "#fff" }}>Task Type</TableCell>
                <TableCell className="fs-14" style={{ color: "#fff", paddingLeft: "50px" }}>
                  Editor
                </TableCell>
                <TableCell className="fs-14" style={{ color: "#fff", paddingLeft: "35px" }}>
                  Job Criteria
                </TableCell>
                <TableCell
                  className="pl-4 fs-14"
                  style={{ color: "#fff", paddingLeft: "35px" }}
                >
                  Questions
                </TableCell>

                <TableCell
                  className="pl-4 fs-14"
                  style={{ color: "#fff", paddingLeft: "35px" }}
                >
                  Holidays
                </TableCell>
                <TableCell
                  className="pl-4 fs-14"
                  style={{ color: "#fff", paddingLeft: "35px" }}
                >
                  Cues
                </TableCell>
                <TableCell
                  className="pl-4 fs-14"
                  style={{ color: "#fff", paddingLeft: "35px" }}
                >
                  Brief
                </TableCell>
                <TableCell className="fs-14" style={{ color: "#fff" }}>Active</TableCell>
                {/* <TableCell></TableCell> */}
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {clientEntityList.map((store) => (
                <TableRow key={store.clientEntityId}>
                  <TableCell className="fs-14">{store.clientEntityId}</TableCell>
                  <TableCell className="fs-14">{store.entityName}</TableCell>
                  <TableCell className="fs-14">{store?.entityTypeId && store?.entityTypeId?.entityTypeName || 'undefined'}</TableCell>
                  <TableCell className="fs-14">
                    <Link
                      to={`/admin/view-editor-business/${store?.clientEntityId}`}
                      // onClick={() => navigateToViewEditors(store)}
                      className="table-row-background link-btn fs-14"
                    >
                      View Editors
                    </Link>
                  </TableCell>
                  <TableCell >
                    <Link
                      to={`/admin/view-business-jobcriteria/${store?.clientEntityId}`}
                      // onClick={() => navigateToViewEditors(store)}
                      className="table-row-background link-btn fs-14"
                    >
                      Job Criteria
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link
                     to={`/admin/create-client-template/${store?.clientEntityId}`}
                      className="table-row-background fs-14 link-btn"
                    >
                      Questions
                    </Link>
                    {/* <Button
                      variant="contained"
                      onClick={() => navigateToClientQuestion(store)}
                      className="table-row-background fs-14"
                    >
                      Questions
                    </Button> */}
                  </TableCell>

                  <TableCell>
                    
                     <Link
                      to={`/admin/addOrUpdateHolidays/${store?.clientEntityId}`}
                      // onClick={() => navigateToViewEditors(store)}
                      className="table-row-background link-btn fs-14"
                    >
                      Holidays
                    </Link>
                  </TableCell>
                  <TableCell>
                    
                     <Link
                      to={`/admin/manage-scenarios/${store?.clientEntityId}`}
                      // onClick={() => navigateToViewEditors(store)}
                      className="table-row-background link-btn fs-14"
                    >
                      Cues
                    </Link>
                  </TableCell>
                  <TableCell>
                     <Link
                      to={`/admin/manage-business-brief/${store?.clientEntityId}`}
                      className="table-row-background link-btn fs-14"
                    >
                      Brief
                    </Link>
                  </TableCell>
                  <TableCell>
                    <div className="switch-admin">
                      <Switch
                        checked={store?.clientEntityStatus?.userStatus === "active"}
                        onChange={(e) => {
                          const newStatus = e.target.checked
                            ? "active"
                            : "inActive";
                          handleChange(store, newStatus); // Pass the store and the new status
                        }}
                        sx={{
                          '& .MuiSwitch-thumb': {
                            backgroundColor: store?.clientEntityStatus?.userStatus === "active" ? "#1976d2" : "#ccc !important"
                          },
                          '& .MuiSwitch-track': {
                            backgroundColor: store?.clientEntityStatus?.userStatus === "active" ? "#90caf9" : "#ccc"
                          }
                        }}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                    </div>
                  </TableCell>
                  {/* <TableCell>
                <IconButton
                  // variant="contained"
                  onClick={() => addOrUpdateStore(store)}
                  // className="table-row-background"
                >
                  <Box component='img' className="w-75" src={edit}></Box>
                </IconButton>
              </TableCell> */}
                  <TableCell>
                    <Link
                      // variant="contained"
                      to={`/admin/add-or-update-store/update/${store?.clientEntityId}`}
                    >
                      <Box component="img" maxWidth={'25px'} src={edit}></Box>
                    </Link>
                    {/* <IconButton
                      // variant="contained"
                      onClick={() => addOrUpdateStore(store)}
                    // className="table-row-background"
                    >
                      <Box component="img" className="w-75" src={edit}></Box>
                    </IconButton> */}
                    <Button
                      variant="contained"
                      className="delete-transparent"
                      onClick={() => {
                        const isConfirmed = window.confirm(
                          "Are you sure you want to delete the Business?"
                        );
                        if (isConfirmed) {
                          deleteStore(store, "delete"); // Call the API or action
                        }
                      }}
                    >
                      <DeleteIcon className="delete-icon" />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={datalength}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </div>
  );
};

export default ManageStore;
